import {
  fetchJson,
  fetchWithAuth,
  ResourceRequestOptions,
  SingleResponse,
  throwOnResponseError,
} from '@soniq/public-resource'
import { PublicProfile } from '@soniq/util-soniqstudio-wasm'

/**
 * Reads a public profile by handle. Works signed out, so it
 * sends no access token.
 */
export function fetchPublicProfile(
  { apiBaseUrl }: Pick<ResourceRequestOptions, 'apiBaseUrl'>,
  handle: string
): Promise<SingleResponse<PublicProfile>> {
  return throwOnResponseError(
    fetchJson<SingleResponse<PublicProfile>>({
      method: 'get',
      baseUrl: apiBaseUrl,
      endpoint: `/v1/profile/${encodeURIComponent(handle)}`,
    })
  )
}

/**
 * Reads the public profile of a profile the signed-in user owns.
 */
export function fetchOwnPublicProfile(
  {
    apiBaseUrl,
    accessToken,
  }: Required<
    Pick<ResourceRequestOptions, 'apiBaseUrl' | 'accessToken'>
  >,
  profileId: string
): Promise<SingleResponse<PublicProfile>> {
  return throwOnResponseError(
    fetchWithAuth<SingleResponse<PublicProfile>>({
      method: 'get',
      baseUrl: apiBaseUrl,
      accessToken,
      endpoint: `/v1/connection/${encodeURIComponent(profileId)}/public_profile`,
    })
  )
}
